module.exports = __webpack_public_path__ + "static/media/wallet-blue.71af4c37.png";